export default function Carousel() {
    $('#hero').each(function (index, sliderWrap) {
        var $slider = $(sliderWrap).find('#hero__gallery');
        $slider.slick({
            dots: false,
            arrows: false,
            speed: 700,
            infinite: true,
            centerMode: false,
            centerPadding: '0',
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            draggable: false,
            touchThreshold: 200,
            pauseOnHover: false,
        });
    });

    $('.split-carousel').each(function (index, sliderWrap) {
        var $slider = $(sliderWrap).find('.split__gallery');
        $slider.slick({
            dots: false,
            arrows: false,
            speed: 500,
            infinite: false,
            slidesToShow: 2.5,
            autoplay: false,
            autoplaySpeed: 4000,
            draggable: true,
            touchThreshold: 100,
            pauseOnHover: true,
            responsive: [
            {
              breakpoint: 650,
              settings: {
                slidesToShow: 1.5,
              }
            }
          ]
        });
    });

    $('.gallery').each(function (index, sliderWrap) {
        var $slider = $(sliderWrap).find('.gallery__carousel');
        $slider.slick({
            dots: true,
            arrows: false,
            speed: 500,
            infinite: true,
            centerMode: false,
            centerPadding: '0',
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            draggable: true,
            touchThreshold: 1000,
            pauseOnHover: true,
            rows: 0,
        });
    });
};  